// extracted by mini-css-extract-plugin
module.exports = {"map":"branch-detail_map__Hhofq","banner":"branch-detail_banner__AGsgm"};